import { doc, getDoc, collection, query, where, getDocs, getFirestore } from 'firebase/firestore';
import firebaseApp from '../../firebase/credenciales';

const db = getFirestore(firebaseApp);

/**
 * Genera el archivo de Pagos Masivos BBVA (Cash Management - Haberes)
 */
export const generarPagosBBVA = async (planillaId) => {
  try {
    const planillaRef = doc(db, "pl_planillas", planillaId);
    const planillaDoc = await getDoc(planillaRef);
    if (!planillaDoc.exists()) throw new Error("Planilla no encontrada");
    const planilla = planillaDoc.data();

    const detalleQuery = query(
      collection(db, "pl_planilla_detalle"),
      where("planilla_id", "==", planillaId)
    );
    const detalleSnapshot = await getDocs(detalleQuery);
    const detalles = [];
    detalleSnapshot.forEach(doc => detalles.push(doc.data()));

    if (detalles.length === 0) throw new Error("No hay trabajadores en esta planilla");

    // Formato simplificado BBVA Cash
    const lineas = detalles.map(d => {
      const tipoDoc = 'L'; // DNI
      const numDoc = String(d.dni || '').padStart(8, '0');
      const nombre = `${d.nombres || ''} ${d.apellidos || ''}`.trim().substring(0, 30).padEnd(30, ' ');
      const monto = Number(d.neto_pagar || 0).toFixed(2).replace('.', '').padStart(15, '0');
      const numCta = String(d.numero_cuenta || '').padEnd(18, ' ');
      const moneda = 'PEN';

      // Estructura: TipoDoc(1) + NumDoc(12) + Nombre(30) + Monto(15) + Cuenta(18) + Moneda(3)
      return `${tipoDoc}${numDoc.padEnd(12, ' ')}${nombre}${monto}${numCta}${moneda}`;
    });

    const contenido = lineas.join('\r\n') + '\r\n';
    const nombreArchivo = `BBVA_PAGOS_${planilla.periodo || 'MARZO_2026'}.txt`;
    
    descargarArchivo(nombreArchivo, contenido);

    return { 
      success: true, 
      message: `Archivo BBVA Cash Management generado (${detalles.length} registros)` 
    };
  } catch (error) {
    console.error("Error generando pagos BBVA:", error);
    throw error;
  }
};

const descargarArchivo = (nombre, contenido) => {
  const blob = new Blob([contenido], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};
